export default __webpack_public_path__ + "static/media/9-spaceship.7f1eaab6.svg";